"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SUB_VENUE_CHECK_IN_OPTIONS = {
    OFF: "OFF",
    ON_CHECK_IN: "ON_CHECK_IN",
    ON_CHECK_OUT: "ON_CHECK_OUT",
};
exports.default = SUB_VENUE_CHECK_IN_OPTIONS;
